"use strict";
exports.__esModule = true;
exports.SvgRow = void 0;
var tslib_1 = require("tslib");
/**
 * This file is generated from 'npm run build-svg'. Any changes should be made to the
 * template in .svgrrc.js or to the source SVG in src/icons/svg.
 **/
var react_1 = tslib_1.__importDefault(require("react"));
exports.SvgRow = function (props) { return (react_1["default"].createElement("svg", tslib_1.__assign({ viewBox: "0 0 24 24", fill: "none" }, props),
    react_1["default"].createElement("path", { d: "M20.91 8.5c.602 0 1.09.597 1.09 1.333v4.334c0 .736-.488 1.333-1.09 1.333H3.09c-.602 0-1.09-.597-1.09-1.333V9.833C2 9.097 2.488 8.5 3.09 8.5h17.82zm-.343 1.5H3.5v4h17.067v-4z", fill: "currentColor" }))); };
//# sourceMappingURL=Row.js.map